const STORAGE_KEY = 'roj.admin.lastOrgId'

export const getLastOrgId = (): string | undefined => {
	if (typeof sessionStorage === 'undefined') return undefined
	return sessionStorage.getItem(STORAGE_KEY) ?? undefined
}

export const setLastOrgId = (id: string): void => {
	if (typeof sessionStorage === 'undefined') return
	sessionStorage.setItem(STORAGE_KEY, id)
}

export const clearLastOrgId = (): void => {
	if (typeof sessionStorage === 'undefined') return
	sessionStorage.removeItem(STORAGE_KEY)
}
